<template>
  <div ref="editor" class="editor-container"></div>
</template>
<script>
import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-sqlserver';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';

// Autocompletion-related imports
import 'ace-builds/src-noconflict/ext-language_tools'; // Importa as ferramentas de autocompletion

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'sqlserver',
    }
  },
  mounted() {
    this.editor = ace.edit(this.$refs.editor);
    this.editor.setTheme(`ace/theme/monokai`);
    this.editor.session.setMode(`ace/mode/${this.language}`);
    this.editor.setValue(this.value, 1);
    this.editor.session.on('change', this.onEditorChange);
    
    //options
    this.editor.setOptions({
      'showLineNumbers': true,
      'showPrintMargin': false,
      'wrap': true,
      'showFoldWidgets': false,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true, // Para mostrar sugestões em tempo real
      enableSnippets: true, // Habilita o uso de snippets, se aplicável
    });
  },
  watch: {
    value(newValue) {
      if (newValue !== this.editor.getValue()) {
        this.editor.setValue(newValue, 1);
      }
    }
  },
  methods: {
    onEditorChange() {
      const content = this.editor.getValue();
      this.$emit('input', content);

      this.editor.session.setMode(`ace/mode/${(this.isJson(content)) ? "json" : this.language}`);
    },
    isJson(code) {
        code = code.trim();
        return code.startsWith('{') || code.startsWith('[');
    }
  },
  beforeUnmount() {
    this.editor.destroy();
  }
};
</script>

<style scoped>
.editor-container {
  height: 500px;
  width: 100%;
}
</style>
  